import { createContext, useContext } from 'react';
import type { ErrorContext } from '@/utils/errorHandlerUtils';

interface ErrorHandlerContextType {
  logError: (error: unknown, context: ErrorContext) => void;
}

// Separado del Provider (ErrorHandlerContext.tsx) para que ese archivo exporte
// solo componentes y React Fast Refresh funcione con él.
export const ErrorHandlerContext = createContext<ErrorHandlerContextType | null>(null);

export function useErrorHandler(): ErrorHandlerContextType {
  const context = useContext(ErrorHandlerContext);
  if (!context) {
    throw new Error('useErrorHandler must be used within an ErrorHandlerProvider');
  }
  return context;
}
